<template>
    <div class="wrapper">
        <p v-if="noPlateScanType == 0 && hintMsg != ''">{{ hintMsg }}</p>
        <p v-if="noPlateScanType == 1 && hintMsg != ''">{{ hintMsg }}</p>
        <div class="div_input" v-if="noPlateScanType == 1 && hintMsg == ''">
            <div class="div_name">请输入车牌号入场</div>
            <plate-input @onChange="getPlateNumber"></plate-input>
            <div class="div_button" @click="getnoPlateManualInput">确认入场</div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
// import plateInput from '../components/plateInput'
import plateInput from '../../components/weChat/components/plateInput.vue'

export default {
    data() {
        return {
            parkinglotInfo: {},
            plateNumber: "",
            noPlateScanType: "0",
            parkingId: 0,
            hintMsg: "",

        };
    },
    components: {
        plateInput
    },
    computed: {
        ...mapGetters(["parkinglotId", "doorId", "areaId", "interfaceManner", "userOpenid", "buyId"])
    },
    created() {
        console.log(2)
    },
    mounted() {
        console.log(3);
        // console.log(this.$encryptUtil.decrypt("pj3JW5yL721frDxn5aPmBg%3D%3D"))
        if (this.$route.query.parkinglotId && this.$route.query.doorId && (localStorage.getItem('userOpenId') || this.userOpenid || localStorage.getItem('userBuyId') || this.buyId)) {
            this.parkingId = this.$encryptUtil.decrypt(
                this.$route.query.parkinglotId
            );
            let door = this.$encryptUtil.decrypt(this.$route.query.doorId);
            console.log(door, 'door');
            this.setParkinglotId(this.parkingId);
            this.setDoorId(door);
            this.$api.area.getAreaIdByDoorId(door).then(res => {
                console.log(res.data, '获取配置');
                this.setAreaId(res.data.data.id);
                this.$api.area.getBasicConfig(this.areaId).then(req => {

                    if (res.data.code == 200) {
                        this.noPlateScanType = req.data.data.noPlateScanType
                        console.log(req.data.noPlateScanType, ' this.noPlateScanType');
                        console.log(res.data.data.interfaceManner, 'res.data.data.interfaceManner');
                        if (req.data.data.noPlateScanType == 0) {
                            this.setInterfaceManner(req.data.data.interfaceManner);
                            this.getNoPlateManual();
                        } else {

                        }

                    }
                })
            });
        }
        // else {
        //     this.$createDialog({
        //         type: "alert",
        //         title: "提示",
        //         content: "请重新扫码",
        //         icon: "cubeic-alert"
        //     }).show();
        // }
    },
    methods: {
        ...mapMutations({
            setParkinglotId: "SET_PARKINGLOTID",
            setDoorId: "SET_DOORID",
            setAreaId: "SET_AREA_ID",
            setInterfaceManner: "SET_INTERFACEMANNER"
        }),


        getPlateNumber(data) {
            console.log('传值', data);
            this.plateNumber = data
        },
        getNoPlateManual() {
            let browser = this.checkBrowser;
            let isOpenId, userOpenid, buyId;
            if (browser.id == 13) {
                isOpenId = true;
                buyId = null;
                userOpenid = localStorage.getItem('userOpenId') || this.userOpenid;
            } else if (browser.id == 12) {
                isOpenId = false;
                buyId = this.buyId || localStorage.getItem('userBuyId');
                userOpenid = null;
            }
            this.$api.parkinglot.noPlateManual(
                this.parkinglotId,
                true,
                this.doorId,
                0,
                isOpenId,
                userOpenid,
                buyId,
                this.areaId,
                this.interfaceManner
            ).then(res => {

                // alert(res.data.msg);
                if (res.data.code == 200) {
                    this.getParkinglotInfo();
                } else {
                    this.$createDialog({
                        type: "alert",
                        title: "提示",
                        content: "抱歉，地感未检测到有车辆",
                        icon: "cubeic-alert"
                    }).show();
                }
            });
        },


        validOnlyOneTruckNo(value) {
            let xny = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([A-HJ-K][A-HJ-NP-Z0-9][0-9]{4}$))/;

            // 燃油车
            let ryc = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
            let isValid = true;
            if (value.length == 7) {
                if (!ryc.test(value)) isValid = false;
            } else if (value.length == 8) {
                if (!xny.test(value)) isValid = false;
            } else {
                isValid = false;
            }
            return isValid;
        },

        getnoPlateManualInput() {
            this.validOnlyOneTruckNo(this.plateNumber)
            let auth = this.validOnlyOneTruckNo(this.plateNumber)
            if (!auth) {
                this.$createDialog({
                    type: "alert",
                    title: "提示",
                    content: "车辆格式不正确",
                    icon: "cubeic-alert"
                }).show();
                return
            }

            let browser = this.checkBrowser;
            let isOpenId, userOpenid, buyId;
            if (browser.id == 13) {
                isOpenId = true;
                buyId = null;
                userOpenid = localStorage.getItem('userOpenId') || this.userOpenid;
            } else if (browser.id == 12) {
                isOpenId = false;
                buyId = this.buyId || localStorage.getItem('userBuyId');
                userOpenid = null;
            }
            this.$api.parkinglot.noPlateManualInput(
                this.parkinglotId,
                true,
                this.doorId,
                0,
                isOpenId,
                userOpenid,
                buyId,
                this.areaId,
                this.interfaceManner,
                this.plateNumber
            ).then(res => {
                console.log(res, '手动入场');
                // alert(res.data.msg);
                if (res.data.code == 200) {
                    this.getParkinglotInfo();
                } else {
                    this.$createDialog({
                        type: "alert",
                        title: "提示",
                        content: "抱歉，地感未检测到有车辆",
                        icon: "cubeic-alert"
                    }).show();
                }
            });
        },
        getParkinglotInfo() {
            if (this.parkinglotId) {
                this.$api.parkinglot.getParkinglotInfo(this.parkinglotId).then(res => {
                    console.log(res.data, '手动入场调用');
                    if (res.data.code == 200 && res.data.data) {
                        this.parkinglotInfo = res.data.data;
                        this.hintMsg = "您好，欢迎进入" + this.parkinglotInfo.parkName;
                    }
                });
            } else {
                // 提示传递参数错误
            }
        }
    },
};
</script>

<style lang="stylus" scoped>
	@import '~common/stylus/variable';
	@import '~common/stylus/mixin';
    

    .wrapper {
		position: relative;
		width: 100%;
		height: 100%;
		background: #f5f5f5;
        
		.div_input {
			background: #ffffff;
			margin-top: 12px;
			padding: 20px;

			.div_name {
				font-size: 16px;
				font-weight: bold;
				line-height: 20px;
				margin-bottom: 25px;
			}

			.div_explain {
				background-color: #fff;
				margin-top: 12px;
				padding: 20px 20px 50px 20px;

				.div_name {
					font-size: 16px;
					margin-bottom: 15px;
					line-height: 20px;
					font-weight: bold;
				}

				.div_text p {
					margin: 0px;
					font-size: 14px;
					line-height: 28px;
				}
			}
			.div_button {
				color: #ffffff;
				width: 100%;
				height: 45px;
				background: #06ae56;
				box-shadow: 0px 5px 5px 0px rgba(84, 149, 246, 0.25);
				border-radius: 5px;
				font-size: 16px;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
				letter-spacing: 3px;
				margin-top: 16px;
			}
		}
	}
    p{
        padding-top: 50%;
        padding-left: 25%;
    }
</style>
